module.exports = __webpack_public_path__ + "media/images/flavours/icon-muscate_dark-84d467efc6ee0458b278faa23fded0f9.png";